import { MapMarkerAlt } from '@emotion-icons/fa-solid/MapMarkerAlt'
import { Colors, Shapes } from 'src/components/theme'
import { SidebarHeader } from 'src/v2/components/sidebar-header'
import { HeaderCover } from 'src/v2/components/sidebar-header-cover'
import { GenericLoader, LoaderCol, LoaderRow } from 'src/v2/components/skeleton-loaders'
import LoadingBg from 'src/assets/images/map-explorer/loading-header.svg'
import { SidebarHeaderContent } from 'src/v2/components/sidebar-header-content'
import { LoadingInsightsPanel } from 'src/components/sidebar/panel'
import styled from '@emotion/styled'
import { Typography } from '@mui/material'
import { FlexColumn } from 'src/components/flex-containers'
import { PaddedBox } from 'src/components/generic/padded-box'

export const SidebarPanelSkeletonLoader = () => {
  return (
    <>
      <SidebarHeader
        cover={
          <HeaderCover
            icon={<MapMarkerAlt color={Colors.bgWhite} />}
            iconBackground={Colors.neutral700}
            iconBorderColor={Colors.neutral100}
            image={LoadingBg}
          />
        }
        content={
          <SidebarHeaderContent>
            <LoaderCol>
              <GenericLoader height={20} width={120} variant="rectangular" color="dark" />
              <GenericLoader height={14} width={180} variant="rectangular" />
              <GenericLoader height={14} width={150} variant="rectangular" color="light" />
            </LoaderCol>
          </SidebarHeaderContent>
        }
      />
      <div
        style={{
          paddingBlock: 24,
          paddingInline: 16,
        }}>
        <GenericLoader height={14} width={120} variant="rectangular" />
      </div>
      <LoadingInsightsPanel rows={2} />
      <div
        style={{
          paddingBlock: 8,
          paddingInline: 16,
        }}>
        <GenericLoader height={14} width={120} variant="rectangular" />
      </div>
      <LoadingInsightsPanel rows={4} />
      <div
        style={{
          paddingBlock: 8,
          paddingInline: 16,
        }}>
        <GenericLoader height={14} width={120} variant="rectangular" />
      </div>
      <LoadingInsightsPanel rows={6} />
    </>
  )
}

const LoaderRowItem = styled(LoaderRow)`
  border: 1px dashed ${Colors.neutral100};
  padding: ${Shapes.spacing[2]}px;
  width: 100%;
  border-radius: ${Shapes.borderRadius}px;
  background-color: ${Colors.bgWhite};
`
export const SidebarResultsSkeletonLoaderItem = () => {
  return (
    <LoaderRowItem>
      <LoaderCol>
        <GenericLoader color="medium" variant="circular" width={30} height={30} animation="wave" />
      </LoaderCol>
      <LoaderCol>
        <GenericLoader variant="rounded" width={160} height={14} animation="wave" color="medium" />
        <GenericLoader variant="rounded" width={195} height={12} animation="wave" />
      </LoaderCol>
    </LoaderRowItem>
  )
}

const SidebarResultsSkeletonLoaderWrapper = styled.div`
  flex: 0;
  display: flex;
  padding: 16px;
  flex-direction: column;
  gap: 16px;
  background-color: ${Colors.bgMedium};
`
export const SidebarResultsSkeletonLoader = () => {
  return (
    <FlexColumn>
      <FlexColumn flex="0">
        <PaddedBox padding={Shapes.spacing[4]}>
          <Typography variant="textmd">Loading Results...</Typography>
        </PaddedBox>
        <SidebarResultsSkeletonLoaderWrapper>
          {[...Array(3)].map((_, index) => (
            <SidebarResultsSkeletonLoaderItem key={`SidebarResultItemLoader-${index}`} />
          ))}
        </SidebarResultsSkeletonLoaderWrapper>
      </FlexColumn>
      <FlexColumn flex="0">
        <PaddedBox padding={Shapes.spacing[4]}>
          <GenericLoader height={16} width={120} variant="text" />
        </PaddedBox>
        <SidebarResultsSkeletonLoaderWrapper>
          {[...Array(3)].map((_, index) => (
            <SidebarResultsSkeletonLoaderItem key={`SidebarResultItemLoader-${index}`} />
          ))}
        </SidebarResultsSkeletonLoaderWrapper>
      </FlexColumn>
    </FlexColumn>
  )
}
